import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const TaskDetailsPageContentWrapper = lazy(() => import("./TaskDetailsPageContentWrapper"));

function TaskDetailsPageInternal() {
    return (
        <DefaultPage>
            <TaskDetailsPageContentWrapper />
        </DefaultPage>
    );
}

export const TaskDetailsPage = withAuthorization(
    getAuthorizationGuard(
        Role.OWNER,
        Role.ADMIN,
        Role.PLANNER,
        Role.EMPLOYEE,
        Role.TEMPORARY_WORKER,
        Role.SUBCONTRACTOR
    )
)(TaskDetailsPageInternal);
